const KeenSlider = window.KeenSlider

const { setInitialised, useDots, useAutoplay } = window.BAO.Carousel.plugins

class UspCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  carouselInitialised = false

  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isMd && !this.carouselInitialised) {
      this.carousel = this.setupCarousel()
    }
  }

  setupListeners () {
    window.addEventListener('resize', () => {
      if (!window.BAO.MediaBreakpoints.isMd && !this.carouselInitialised) {
        this.carousel = this.setupCarousel()
      }
    })
  }

  setupCarousel () {
    if (this.carouselInitialised) return
    this.carouselInitialised = true

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 1,
        },
        breakpoints: {
          '(min-width: 901px)': {
            loop: false,
            slides: {
              perView: 4,
            },
          },
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        useAutoplay(4, { pauseOnHover: false }),
      ],
    )
  }
}

if (!customElements.get('usp-carousel')) {
  customElements.define('usp-carousel', UspCarousel)
}
